import React, { FC } from 'react'

import { Typography, useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import { CircularProgressbar } from 'react-circular-progressbar'
import { useTranslation } from 'react-i18next'

import { useAppDispatch, useAppSelector } from '../../../store/hooks'
import { toggleBigWidget } from '../DashboardSlice'
import { BigWidgetsName } from '../types'
import { WidgetWrapper } from '../widgetsComponents'

export const WinRatio: FC = () => {
  const { t } = useTranslation()
  const { spacing, palette } = useTheme()
  const dispatch = useAppDispatch()

  const { widgetsData, bigWidgetsList } = useAppSelector(({ dashboard }) => dashboard)

  const winning = widgetsData?.winRatio?.winningTrades
    ? Number(widgetsData.winRatio.winningTrades)
    : 0
  const losing = widgetsData?.winRatio?.loosingTrades
    ? Number(widgetsData.winRatio.loosingTrades)
    : 0

  const percentage = (winning / (winning + losing)) * 100

  const handleCheck = () => {
    dispatch(toggleBigWidget(BigWidgetsName.winRatio))
  }

  return (
    <WidgetWrapper
      label={t('winRatio', 'Win ratio')}
      handleCheck={handleCheck}
      isChecked={bigWidgetsList[BigWidgetsName.winRatio]}
      explanation={t(
        'representsTheRatioOfWinnersVsLosers',
        'Represents the ratio of winners vs losers',
      )}
    >
      <Box display="flex" alignItems="center" height="100%">
        <Box width={spacing(15.5)} height={spacing(15.5)}>
          <CircularProgressbar
            value={isNaN(percentage) ? 0 : percentage}
            text={isNaN(percentage) ? '-' : `${percentage.toFixed(1)}%`}
            styles={{
              path: {
                stroke: palette.green[400],
                strokeLinecap: 'butt',
                transition: 'stroke-dashoffset 0.5s ease 0s',
                transformOrigin: 'center center',
              },
              trail: {
                stroke: palette.grey[500],
                strokeLinecap: 'butt',
                transformOrigin: 'center center',
              },
              text: {
                fill: palette.text.primary,
                fontSize: spacing(3),
                fontWeight: 'bold',
                fontFamily: 'Wix Madefor Display',
                textAnchor: 'middle',
                transform: 'translate(0, 6px)',
              },
              background: {
                fill: palette.cyan[500],
              },
            }}
            strokeWidth={6}
          />
        </Box>
        <Box
          flex={1}
          display="flex"
          flexDirection="column"
          gap={spacing(1.25)}
          justifyContent="center"
          alignItems="center"
        >
          <Box>
            <Typography fontWeight="bold" color={palette.grey[700]} fontSize={spacing(1.5)}>
              {t('winningTrades', 'Winning trades')}
            </Typography>
            <Typography variant="h4">{winning || '-'}</Typography>
          </Box>
          <Box>
            <Typography fontWeight="bold" color={palette.grey[700]} fontSize={spacing(1.5)}>
              {t('losingTrades', 'Losing trades')}
            </Typography>
            <Typography variant="h4">{losing || '-'}</Typography>
          </Box>
        </Box>
      </Box>
    </WidgetWrapper>
  )
}
